<template>
  <form class="d-flex align-items-center flex-wrap" @submit.prevent>
    <button type="button" class="btn export-import" @click="downloadSettings"><i class="fa-solid fa-cloud-arrow-down"></i> Export</button>
    <div class="btn export-import uploadbox">
      <input type="file" name="settingsArchive" :disabled="isUploading" ref="fileupload"
             @change="uploadFileChange($event.target.files)"
             accept="application/zip" class="input-file">
      <div class="uploadbox-text">
        <i class="fa-solid fa-cloud-arrow-up" aria-hidden="true"></i>
        <span>{{uploadboxText}}</span>
      </div>
      <UploadConfirmationModal @cancel="cancelUploadSettings" @confirm="uploadSettings" />
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import { routesNames, uploadStatus } from '@/core/constants'
import UploadConfirmationModal from './UploadConfirmationModal'

export default {
  data() {
    return {
      uploadedFiles: [],
      currentUploadStatus: null
    }
  },
  components: {
    UploadConfirmationModal
  },
  computed: {
    ...mapGetters([
      'currentTenant',
      'isAdmin'
    ]),
    isUploading() {
      return this.currentUploadStatus === uploadStatus.Uploading
    },
    uploadboxText() {
      return this.currentUploadStatus === uploadStatus.Uploading ? 'Uploading...' : 'Upload'
    },
    showUploadSettingsConfirmationModal() {
      return window.runtimeConfig.uploadConfirmationEnabled
    }
  },
  methods: {
    downloadSettings() {
      if (this.currentTenant !== '') {
        this.$store.dispatch('getAllSettings')
          .then(response => {
            const fileURL = window.URL.createObjectURL(new Blob([response.data]))
            const fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', 'adminPortalSettings_' + this.currentTenant + '_' + window.location.hostname + '.zip')
            document.body.appendChild(fileLink)
            fileLink.click()
          })
          .catch(err => {
            this.$notify({
              title: 'Download Settings',
              text: 'Something went wrong while fetching configuration archive: ' + err,
              type: 'error',
              duration: 15000
            })
          })
      }
    },
    uploadFileChange(fileList) {
      // handle file changes, allow only one file at a time
      if (!fileList.length || !fileList.length > 1) return

      this.settingsArchiveFile = fileList[0]

      this.$modal.show('dialog', {
        title: 'Upload Settings',
        text:
          'Are you sure you want to update all settings for tenant ' + this.currentTenant + ' with archive file: ' + this.settingsArchiveFile.name + '?',
        buttons: [
          {
            title: 'Cancel',
            handler: () => {
              this.$modal.hide('dialog')
              this.$refs.fileupload.value = null
              this.settingsArchiveFile = null
            }
          },
          {
            title: 'Upload and Save',
            default: true,
            handler: () => {
              this.$modal.hide('dialog')
              if (this.showUploadSettingsConfirmationModal) {
                this.$modal.show('upload-confirmation-modal')
                return
              }
              this.uploadSettings()
            }
          }
        ]
      })
    },
    uploadSettings() {
      if (!this.settingsArchiveFile) {
        this.currentUploadStatus = uploadStatus.Failed

        this.$notify({
          title: 'Upload Settings',
          text: 'Something went wrong while uploading configuration archive: could not find the file',
          type: 'error',
          duration: 15000
        })
      }

      // upload data to the server
      if (this.currentTenant !== '') {
        this.currentUploadStatus = uploadStatus.Uploading

        this.$store.dispatch('uploadSettings', this.settingsArchiveFile, this.currentTenant)
          .then(x => {
            this.uploadedFiles = [].concat(x)
            this.currentUploadStatus = uploadStatus.Success
            this.$notify({
              title: 'Upload Settings',
              text: 'Successfully updated settings from file: ' + this.settingsArchiveFile.name,
              type: 'success',
              duration: 15000
            })
          })
          .catch(err => {
            this.currentUploadStatus = uploadStatus.Failed

            this.$notify({
              title: 'Upload Settings',
              text: 'Something went wrong while uploading configuration archive: ' + err,
              type: 'error',
              duration: 15000
            })
          })
          .finally(() => {
            this.updateEditorData()
            this.$refs.fileupload.value = null
            this.settingsArchiveFile = null
          })
      }
    },
    cancelUploadSettings() {
      this.$refs.fileupload.value = null
      this.settingsArchiveFile = null
    },
    updateEditorData() {
      if (this.$route.name === routesNames.auditLogs) {
        this.$store.dispatch('getAuditLogs')
        return
      }

      if (this.$route.name === routesNames.history) {
        this.$store.dispatch('getHistoryRecords')
        return
      }

      this.$store.dispatch('getEditorData')
    },
    resetUploadStatus() {
      // reset form to initial upload state
      this.currentUploadStatus = uploadStatus.Initial
      this.uploadedFiles = []
    }
  },
  mounted() {
    this.resetUploadStatus()
  }
}
</script>

<style scoped>
.export-import {
  margin: 5px;
  color: var(--bs-body-color);
  background: var(--bs-secondary-bg);
  height: 38px;
}

.uploadbox-text {
  pointer-events: none;
}

.uploadbox {
  outline: 2px dashed grey;
  outline-offset: -4px;
  display: inline-flex;
  position: relative;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  cursor: pointer;
}

.uploadbox:hover {
  outline-color: var(--bs-primary);
  color: #fff;
  background: var(--bs-primary); /* when mouse over to the drop zone, change color */
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ExportImportSettings.vue